<template>
  <v-flex>
    <v-card>
      <v-card-title>
        <slot name="content"></slot>
      </v-card-title>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: "rTextBox"
};
</script>

<style scoped>
.text-box {
  border: 2px solid #e5e5e5;
  padding: 1em;
}
</style>
